// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"390":"0d8bf285","488":"5a7a2ca8","885":"542196e0"}[chunkId] + ".chunk.js";
};